import { ORDER_LIST, ORDER_DATE_FILTER, ORDER_DATE_RANGE_FILTER } from '../../mutationTypes'

const mutations = {
  [ORDER_DATE_RANGE_FILTER](state, action){
    state.filterDateFrom = action.dateFrom;
    state.filterDateTo = action.dateTo;
  },
  [ORDER_DATE_FILTER](state, action){
    state.filterDate = action.date
  },
  [ORDER_LIST](state, action){
    state.items = action.items
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./client/store/modules/order/orderMutations.js